import { FrameName } from "../config";
import SettlementEmptyTerrainTileEntity from "./SettlementEmptyTerrainTileEntity";

class SettlementEmpty4TerrainTileEntity extends SettlementEmptyTerrainTileEntity {
	public static readonly frameName = FrameName.SETTLEMENT_EMPTY4;
}

export default SettlementEmpty4TerrainTileEntity;
